import React, { memo, useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import SSPList from '../../../../../common/components/SSPList';
import { changeFilter, changePageOrSize, listClearData } from '../../../../../common/components/SSPList/actions';
import { demoEdgeMockActivities } from '../../../mocks/demoEdgeMockActivities';
import { getEdgeActivities } from '../store/actions';
import { edgeActivitiesDefaultSorting, makeActivitiesFilters } from '../lib/demoEdgeActivitiesColumns';
import { downloadActivitiesCsv } from '../lib/demoEdgeActivitiesCsvBuilder';

import '../styles/_styles.scss';
import { EDGE_ACTIVITIES_TABLE_ID } from '../const/common';

const DemoEdgeActivities = memo(
  ({ edgeControllerId, onGetDataAction: onGetDataActionProp, onExport: onExportProp, exportLimit = 5000 }) => {
    const dispatch = useDispatch();

    useEffect(
      () => () => {
        dispatch(changeFilter(EDGE_ACTIVITIES_TABLE_ID, null));
        dispatch(changePageOrSize(EDGE_ACTIVITIES_TABLE_ID, 0, 20));
        dispatch(listClearData(EDGE_ACTIVITIES_TABLE_ID));
      },
      [dispatch],
    );

    const rows = useMemo(
      () =>
        edgeControllerId ? demoEdgeMockActivities.filter((a) => a.targetEdgeControllerId === edgeControllerId) : demoEdgeMockActivities,
      [edgeControllerId],
    );

    const columns = useMemo(() => makeActivitiesFilters(), []);

    const onGetDataAction = useMemo(() => {
      if (onGetDataActionProp) return onGetDataActionProp;

      const thunkFactory = getEdgeActivities(rows);

      return (id, opts) => dispatch(thunkFactory(id, opts));
    }, [onGetDataActionProp, dispatch, rows]);

    const onExport = useMemo(() => {
      if (onExportProp) return onExportProp;

      return (exportParams) => {
        downloadActivitiesCsv(rows, exportParams);

        return Promise.resolve();
      };
    }, [onExportProp, rows]);

    return (
      <div className="edge-activities-table" style={{ width: '100%', height: 'calc(100dvh - 145px)' }}>
        <SSPList
          checkboxSticky
          mobileSticky
          multiselect
          exportable
          onExport={onExport}
          exportLimit={exportLimit}
          onGetDataAction={onGetDataAction}
          defaultPageSize={20}
          defaultSorted={edgeActivitiesDefaultSorting}
          id={EDGE_ACTIVITIES_TABLE_ID}
          columns={columns}
          filterable
          rowsFreeHeight
          optStyles={{ height: '100%' }}
        />
      </div>
    );
  },
);

export default DemoEdgeActivities;
